// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__23jDe","footer":"Form_footer__GhAyM"};